import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a44eb0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal fade",
  id: "template-select-modal",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "template-select-modal-title",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "template-select-modal-title"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "form-check"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Select All", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "form-check"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Default", -1))
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 4,
  class: "form-check"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Unfurnished", -1))
const _hoisted_20 = { key: 5 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 6,
  class: "form-check"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Part furnished", -1))
const _hoisted_27 = { key: 7 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 8,
  class: "form-check"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Fully furnished", -1))
const _hoisted_34 = { key: 9 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 10,
  class: "form-check"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Fully furnished with linen", -1))
const _hoisted_41 = { key: 11 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary",
    "data-dismiss": "modal"
  }, " OK ")
], -1))

import { computed, inject, reactive } from 'vue';
import _ from 'lodash';
import { useStore } from 'vuex';
import { DictionaryState } from '@/store/dictionary/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateSelectModal',
  setup(__props) {

const store = useStore();

const dictionaryState = computed(() => store.state.dictionary as DictionaryState);
const hasActiveSection = computed(() => store.getters['dictionary/hasActiveSection']);
const hasActiveType = computed(() => store.getters['dictionary/hasActiveType']);
const hasActiveRoom = computed(() => store.getters['dictionary/hasActiveRoom']);
const hasActiveRoomCategory = computed(() => store.getters['dictionary/hasActiveRoomCategory']);

const defaultVal = computed({
  get: () => checkForFurnitureBit(1), // 00001
  set: (val: boolean) => setFurnitureBit(1, val)
});

const unfurnishedVal = computed({
  get: () => checkForFurnitureBit(2), // 00010
  set: (val: boolean) => setFurnitureBit(2, val)
});

const partFurnishedVal = computed({
  get: () => checkForFurnitureBit(4), // 00100
  set: (val: boolean) => setFurnitureBit(4, val)
});

const fullyFurnishedVal = computed({
  get: () => checkForFurnitureBit(8), // 01000
  set: (val: boolean) => setFurnitureBit(8, val)
});

const fullyFurnishedWithLinenVal = computed({
  get: () => checkForFurnitureBit(16), // 10000
  set: (val: boolean) => setFurnitureBit(16, val)
});

const selectAllVal = computed({
  get() {
    return defaultVal.value &&
           unfurnishedVal.value &&
           partFurnishedVal.value &&
           fullyFurnishedVal.value &&
           fullyFurnishedWithLinenVal.value;
  },
  set(val: boolean) {
    defaultVal.value = val;
    unfurnishedVal.value = val;
    partFurnishedVal.value = val;
    fullyFurnishedVal.value = val;
    fullyFurnishedWithLinenVal.value = val;
  }
});

const checkForFurnitureBit = (num: number) => {
  if (!hasActiveSection.value || !hasActiveType.value) {
    return false;
  }
  const room = _.find(dictionaryState.value.current.rooms, room => room === dictionaryState.value.activeRoom);
  if (room === undefined) {
    return false;
  }
  const slug = `${dictionaryState.value.activeSection.slug}/${dictionaryState.value.activeType.slug}`;
  const hasSlug = _.has(room.types, slug);
  const flagOn = room.types[slug] & num;
  return Boolean(hasSlug && flagOn);
}

const setFurnitureBit = (flag: number, selected: boolean) => {
  if (hasActiveRoom.value) {
    store.commit('dictionary/setTemplateTypesForRoom', {flag, selected});
  }
  if (hasActiveRoomCategory.value) {
    store.commit('dictionary/setTemplateTypesForCategory', {flag, selected});
  }
}

const modalTitle = () => {
  let room = 'ERROR';
  if (hasActiveRoomCategory.value) {
    room = `CAT ${store.state.dictionary.activeRoomCategory}`;
  } else {
    room = store.state.dictionary.activeRoom.name;
  }
  return `${room} / ${store.state.dictionary.activeType.getSystemName()}`;
}

return (_ctx: any,_cache: any) => {
  return (hasActiveType.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(modalTitle()), 1),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              (hasActiveRoom.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "selectAll",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectAllVal).value = $event))
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        selectAllVal.value,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _hoisted_9
                  ]))
                : _createCommentVNode("", true),
              (hasActiveRoom.value)
                ? (_openBlock(), _createElementBlock("hr", _hoisted_10))
                : _createCommentVNode("", true),
              (hasActiveRoom.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((defaultVal).value = $event))
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        defaultVal.value,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _hoisted_12
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-link",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (defaultVal.value = true))
                    }, _hoisted_15),
                    _createTextVNode("  "),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-link",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (defaultVal.value = false))
                    }, _hoisted_17),
                    _createTextVNode("  Default ")
                  ])),
              (hasActiveRoom.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((unfurnishedVal).value = $event))
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        unfurnishedVal.value,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _hoisted_19
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-link",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (unfurnishedVal.value = true))
                    }, _hoisted_22),
                    _createTextVNode("  "),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-link",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (unfurnishedVal.value = false))
                    }, _hoisted_24),
                    _createTextVNode("  Unfurnished ")
                  ])),
              (hasActiveRoom.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((partFurnishedVal).value = $event))
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        partFurnishedVal.value,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _hoisted_26
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-link",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (partFurnishedVal.value = true))
                    }, _hoisted_29),
                    _createTextVNode("  "),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-link",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (partFurnishedVal.value = false))
                    }, _hoisted_31),
                    _createTextVNode("  Part furnished ")
                  ])),
              (hasActiveRoom.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((fullyFurnishedVal).value = $event))
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        fullyFurnishedVal.value,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _hoisted_33
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-link",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (fullyFurnishedVal.value = true))
                    }, _hoisted_36),
                    _createTextVNode("  "),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-link",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (fullyFurnishedVal.value = false))
                    }, _hoisted_38),
                    _createTextVNode("  Fully furnished ")
                  ])),
              (hasActiveRoom.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((fullyFurnishedWithLinenVal).value = $event))
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        fullyFurnishedWithLinenVal.value,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _hoisted_40
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-link",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (fullyFurnishedWithLinenVal.value = true))
                    }, _hoisted_43),
                    _createTextVNode("  "),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-link",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (fullyFurnishedWithLinenVal.value = false))
                    }, _hoisted_45),
                    _createTextVNode("  Fully furnished with linen ")
                  ]))
            ]),
            _hoisted_46
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})